import { Box, Card, CardHeader, Chip } from '@mui/material'
import { TYPOGRAPHY_MIXIN } from 'src/shared/constants/styling-constants'
import styled from 'styled-components'

export const ConfigurationSortCardBoxStyled = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`

export const ConfigurationSortCardStyled = styled(Card).withConfig({
  shouldForwardProp: (prop) => !['greyedOut', 'transparent'].includes(prop),
})<{ greyedOut?: boolean; transparent?: boolean }>`
  &:hover {
    box-shadow: ${({ transparent, theme }) => (!transparent ? theme.shadows[4] : 'none')};
  }

  ${({ transparent }) =>
    transparent &&
    `
    box-shadow: none;
    background-color: transparent;
  `}
  ${({ greyedOut }) =>
    greyedOut &&
    `.MuiCardHeader-content {
        opacity: 0.3;
      }
    `}
  .header-wrapper {
    display: flex;
    justify-content: space-between;
    cursor: default;

    .header-content {
      flex-grow: 1;

      &:hover ~ .header-actions .expand-button {
        background-color: ${({ theme }) => theme.colors.action.hover};
        transition: ${({ theme }) =>
          theme.transitions.create('all', { duration: theme.transitions.duration.standard })};
      }
    }
  }
`

export const ConfigurationSortCardHeaderStyled = styled(CardHeader)`
  height: 3rem;
  display: flex;
  justify-content: center;
  flex-grow: 1;
  padding-right: ${({ theme }) => theme.spacing(3)};

  & .MuiCardHeader-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  & .MuiCardHeader-action {
    display: flex;
    align-items: end;
    justify-content: space-between;
    align-self: center;
  }
`

export const ConfigurationSortCardIdChipStyled = styled(Chip)`
  cursor: pointer;
  min-width: 4rem;

  &.MuiChip-filledDefault {
    background-color: ${({ theme }) => theme.colors.action.hover};
    color: ${({ theme }) => theme.colors.text.disabled};
  }

  & .MuiChip-label {
    ${TYPOGRAPHY_MIXIN.subtitle2};
    line-height: initial;
  }
`

export const ConfigurationSortCardMoveButtonsStyled = styled('div')`
  display: flex;

  & .MuiIconButton-root {
    width: 1.5rem;
    height: 1.5rem;
    padding: 0;

    &:first-child {
      margin-right: ${({ theme }) => theme.spacing(0.5)};
    }

    &:hover {
      color: ${({ theme }) => theme.colors.primary.dark};
    }
  }

  & .MuiSvgIcon-root {
    font-size: 1.25rem;
  }
`
